import script from "./TGestaoTravamento.vue?vue&type=script&setup=true&lang=ts"
export * from "./TGestaoTravamento.vue?vue&type=script&setup=true&lang=ts"

import "./TGestaoTravamento.vue?vue&type=style&index=0&id=3448b759&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3448b759"]])

export default __exports__